export default "__VITE_ASSET__CzbTXF9e__"